module.exports = __webpack_public_path__ + "static/header-bannerbg-ironcapx-min-aa5f9d9b73edc9e6acdc55be894aa0a4.png";